export function focusNext(e) {
  const inputs = Array.from(e.target.form.querySelectorAll('input[type="text"], input[type="password"], textarea'))
  const nextIndex = inputs.indexOf(e.target) + 1

  if (nextIndex < inputs.length) {
    inputs[nextIndex].focus()
  }
}
